import { Link } from "react-router-dom";
import { AlertTriangle, Send } from "lucide-react";
import { Logo } from "@/components/ui/Logo";
import { RISK_DISCLAIMER, FOOTER_LINKS } from "@/constants/site";

export const Footer = ({ config }) => (
  <footer
    className="relative mt-8"
    style={{
      background: "var(--gm-navy-950)",
      borderTop: "1px solid rgba(255,255,255,0.1)",
    }}
  >
    <div className="gm-container py-12 sm:py-16">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo size={44} testId="footer-logo" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed" style={{ color: "var(--gm-muted)" }}>
            Rule-based gold automation for MetaTrader 4 and 5. Built for traders who
            prefer a routine over a hunch.
          </p>
          <a
            href={config?.telegram_channel || "#"}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-telegram-link"
            aria-label="Open Telegram in a new tab"
            className="gm-btn-ghost mt-5 inline-flex min-h-[44px] items-center gap-2 rounded-xl px-4 text-sm font-semibold"
          >
            <Send className="h-4 w-4" />
            Join us on Telegram
          </a>
        </div>

        <div className="md:col-span-3">
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Explore
          </h3>
          <ul className="mt-4 space-y-2.5">
            {FOOTER_LINKS.map((l) => (
              <li key={l.id}>
                <a
                  href={`/#${l.id}`}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm hover:text-white"
                  style={{ color: "var(--gm-muted)" }}
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Get started
          </h3>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link
                to="/free-access"
                data-testid="footer-link-free-access"
                className="text-sm hover:text-white"
                style={{ color: "var(--gm-muted)" }}
              >
                Apply for free access
              </Link>
            </li>
            <li>
              <Link
                to="/downloads"
                data-testid="footer-link-downloads"
                className="text-sm hover:text-white"
                style={{ color: "var(--gm-muted)" }}
              >
                Downloads and presets
              </Link>
            </li>
            <li>
              <Link
                to="/faq"
                data-testid="footer-link-faq"
                className="text-sm hover:text-white"
                style={{ color: "var(--gm-muted)" }}
              >
                All questions
              </Link>
            </li>
            <li>
              <a
                href={`mailto:${config?.support_email || "support@goldmapea.com"}`}
                data-testid="footer-link-email"
                className="text-sm hover:text-white"
                style={{ color: "var(--gm-muted)" }}
              >
                {config?.support_email || "support@goldmapea.com"}
              </a>
            </li>
            <li>
              <Link
                to="/admin"
                data-testid="footer-link-admin"
                className="text-sm hover:text-white"
                style={{ color: "var(--gm-muted-2)" }}
              >
                Owner login
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        data-testid="risk-disclaimer"
        className="mt-12 flex gap-3 rounded-xl p-4 sm:p-5"
        style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <AlertTriangle
          className="mt-0.5 h-5 w-5 shrink-0"
          style={{ color: "var(--gm-warning)" }}
          aria-hidden="true"
        />
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-white">Risk warning</p>
          <p className="mt-1.5 text-xs leading-relaxed" style={{ color: "var(--gm-muted-2)" }}>
            {RISK_DISCLAIMER}
          </p>
        </div>
      </div>

      <div
        className="mt-8 flex flex-col gap-2 pt-6 text-xs sm:flex-row sm:items-center sm:justify-between"
        style={{ borderTop: "1px solid rgba(255,255,255,0.08)", color: "var(--gm-muted-2)" }}
      >
        <p>
          &copy; {new Date().getFullYear()} Goldmap EA. All rights reserved.
        </p>
        <p>Build {config?.version || "v4.2.3"} &middot; MetaTrader 4 and 5</p>
      </div>
    </div>
  </footer>
);
